const fallbackSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="800" height="1000" viewBox="0 0 800 1000">
  <rect width="800" height="1000" fill="#141414"/>
  <rect x="80" y="80" width="640" height="840" fill="#0A0A0A" stroke="#2A2A2A" stroke-width="2"/>
  <circle cx="400" cy="420" r="82" fill="none" stroke="#D4AF37" stroke-width="18"/>
  <path d="M285 560h230l70 130H215z" fill="none" stroke="#D4AF37" stroke-width="18" stroke-linejoin="round"/>
  <text x="400" y="790" text-anchor="middle" fill="#A3A3A3" font-family="Arial, sans-serif" font-size="42">Image unavailable</text>
</svg>`;

export const FALLBACK_IMAGE = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(fallbackSvg)}`;

export const resolveImageUrl = (url, backendUrl = '') => {
  if (!url || typeof url !== 'string') return FALLBACK_IMAGE;

  const trimmed = url.trim();
  if (!trimmed) return FALLBACK_IMAGE;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('data:') || trimmed.startsWith('blob:')) {
    return trimmed;
  }
  if (trimmed.startsWith('//')) return `https:${trimmed}`;
  if (trimmed.startsWith('/')) return backendUrl ? `${backendUrl}${trimmed}` : trimmed;

  return backendUrl ? `${backendUrl}/uploads/${trimmed}` : trimmed;
};

export const imageFallback = (event) => {
  event.currentTarget.onerror = null;
  event.currentTarget.src = FALLBACK_IMAGE;
};
